"use client";

import { Anchor, Box, Breadcrumbs, Group, Select } from "@mantine/core";
import { useRouter } from "next/navigation";

import { NextLink } from "@/app/lib/components/next/NextLink";

import { DECISION_MAKING_FRAMEWORKS, type DecisionMakingFramework } from "../constants";

interface FrameworkBreadcrumbProps {
  framework: DecisionMakingFramework;
}

export function FrameworkBreadcrumb({ framework }: FrameworkBreadcrumbProps) {
  const router = useRouter();

  const frameworkOptions = Object.values(DECISION_MAKING_FRAMEWORKS).map((framework) => ({
    value: framework.help_url,
    label: framework.name,
  }));

  const handleFrameworkChange = (value: string | null) => {
    if (value) {
      router.push(value);
    }
  };

  return (
    <Box mb="lg">
      <Breadcrumbs>
        <Anchor component={NextLink} href="/decision-making-frameworks">
          Decision Frameworks
        </Anchor>

        <Group gap="xs">
          <Select
            size="md"
            rightSection={<span />}
            variant="unstyled"
            data={frameworkOptions}
            value={framework.help_url}
            onChange={handleFrameworkChange}
            comboboxProps={{
              width: 300,
            }}
            withCheckIcon={false}
            styles={{
              input: { color: "var(--mantine-color-blue-6)" },
            }}
          />
        </Group>
      </Breadcrumbs>
    </Box>
  );
}
